"use strict";
/*
 * Created on 5. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");

var DateUtils_1 = require("../../core/utils/DateUtils");

var OptimizationGoalsSettings_1 = require("../../general-settings/model/optimalization-goal/OptimizationGoalsSettings");

var CompanyVsCRPChangeIndex_1 = require("../../price-calculation/model/CompanyVsCRPChangeIndex");

var CompetitorReferentialPrice_1 = require("../../price-calculation/model/CompetitorReferentialPrice");

var ReferencePrice_1 = require("../../price-calculation/model/ReferencePrice");

var ExportedPriceHistory_1 = require("../../price-list/model/ExportedPriceHistory");

var PriceStats_1 = require("../../price-list/model/PriceStats");

var PriceChangeIndex_1 = require("../../product/model/PriceChangeIndex");

var ProductPrice_1 = require("../../product/model/ProductPrice");

var RegularProductPrice_1 = require("../../product/model/RegularProductPrice");

var FinalProductPrice_1 = require("./FinalProductPrice");

var OptimalPrice_1 = require("./OptimalPrice");

var PriceComment_1 = require("./PriceComment");

var RealImpactValue_1 = require("./RealImpactValue");

var ReleaseItemRepricing_1 = require("./ReleaseItemRepricing");
/**
 * Prices within a release that are valid for given price zone.
 * @author Radek Beran
 */


var PriceZoneReleasePrices =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceZoneReleasePrices, _DomainObject_1$Domai);

  /**
   * Creates release item prices for given price zone.
   * @param priceZoneId
   * @param competitorReferencePrice approved competitor reference price copied into the release
   * @param competitorReferencePrices approved competitor reference prices for current product and price zone
   * (and all available competitors)
   * @param referencePriceOld old reference price from the last released release
   * @param referencePrice new suggested reference price (based on settings, category and price zone), computed when release is opened
   * @param referencePriceChangeIndexPercent [(referencePrice - referencePriceOld)/referencePriceOld] * 100 [%]
   * @param optimalPriceWithConstraints optimal price with constraints, computed when release is opened
   * @param optimalPriceWithoutConstraints optimal price without constraints, computed when release is opened
   * @param edlpPrice EDLP price valid in the time of {@link Release.priceValidityStartDate} or null if there is no such valid price for
   *        the product in the specified time.
   * @param regularPrice actual regular price (ARP)
   * @param regularPriceChangeIndexPercent (Final price change index [%])
   *        [(new final price - actual regular price)/actual regular price] * 100 [%]
   * @param regularPriceChangeWeightedIndexPercent computed as
   *        [(new regular sales forecast - old regular sales forecast)/old regular sales forecast] * 100 [%], forecasts come from YDG,
   *        "weight" means predicted regular sales volume.
   * @param companyVsReferencePriceChangeIndexPercent (Albert vs Reference price change index [%])
   *        [(new final price - reference price)/reference price] * 100 [%]
   * @param companyVsCRPChangeIndices indices for individual competitors,
   *        computed as [(new competitor price - regular price)/regular price] * 100 [%]
   * @param promoPriceStats contains some statistic about product's promo prices
   * @param marginOldUnit [CZK]
   * @param marginOld [CZK], value may be weighted by forecast
   * @param marginOldPercent (time dependent) computed as
   *        bm2 = [(actual regular price - purchase price + vendor allowances)/actual regular price] * 100 [%];
   *        (vendor allowances = purchase price * % va from VendorAllowance entity)
   *        the same weight as for marginOld is used
   * @param marginNewUnit [CZK] computed as bm2 = new final price - purchase price + vendor allowances;
   * @param marginNew [CZK] computed as bm2 = new final price - purchase price + vendor allowances; value may be weighted by forecast
   * @param marginNewPercent (time dependent) computed as
   *        bm2 = [(new final price - purchase price + vendor allowances)/new final price] * 100 [%]
   *        (vendor allowances = purchase price * % va from VendorAllowance entity)
   * @param marginImpact (delta margin - BM2) computed as (marginNew - marginOld) [CZK]
   * @param marginImpactPercent (time dependent) computed as (marginNewPercent - marginOldPercent) [%]
   * @param salesVolumeOld (time dependent) oldForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) by using current regular price for reported days).
   * @param salesVolumeNew (time dependent) newForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) by using new final price for reported days)
   * If new final price is chosen from optimal price, use newForecast from Yieldigo,
   * if new final price is chosen from last regular price, use oldForecast from Yieldigo,
   * if new final price is chosen as new manual price, call Yieldigo with price range <manual price; manual price>
   * @param salesVolumeImpact (delta quantity) (time dependent) computed as
   * salesVolumeNew - salesVolumeOld [unit of sales volume (kg, ks, ...)]
   * @param revenueOld (time dependent) computed as salesVolumeOld * actual regular price [CZK]
   * @param revenueNew (time dependent) computed as salesVolumeNew * new final price [CZK]
   * @param revenueImpact (delta sales) (time dependent) computed as (revenueNew - revenueOld) [CZK]
   * @param revenueImpactPercent (time dependent) computed as [(revenueNew - revenueOld)/revenueOld] * 100 [%]
   * @param profitOldUnit computed as (actual regular price - actual purchase price) [CZK]
   * @param profitOld computed as (actual regular price - actual purchase price) [CZK], value may be weighted by forecast
   * @param profitOldPercent computed as [(regular price - purchase price)/regular price] * 100 [%]
   * @param profitNewUnit computed as (new final price - actual purchase price) [CZK]
   * @param profitNew computed as (new final price - actual purchase price) [CZK], value may be weighted by forecast
   * @param profitNewPercent computed as [(final price - purchase price)/final price] * 100 [%]
   * @param profitImpact (delta profit - BM1) computed as (profitNew - profitOld) [CZK]
   * @param profitImpactPercent computed as profitNewPercent - profitOldPercent [%]
   * @param priceElasticity computed as e = x/(x - 1.1), YDG returns x value on product and price zone level
   * @param optimizationGoal
   * @param finalPrice final price for item re-pricing (will become the new regular price of product)
   * @param exportedPriceHistory Wrapper of exported prices.
   * @param priceCode price code, identifier of {@link PriceCode}
   * @param repricing Contains information about possibility of repricing and corresponding reasons.
   * @param comments list of comments (comments on final price)
   * @param realImpact
   */
  function PriceZoneReleasePrices(priceZoneId, competitorReferencePrice, competitorReferencePrices, referencePriceOld, referencePrice, referencePriceChangeIndexPercent, optimalPriceWithConstraints, optimalPriceWithoutConstraints, edlpPrice, regularPrice, regularPriceChangeIndexPercent, regularPriceChangeWeightedIndexPercent, companyVsReferencePriceChangeIndexPercent, companyVsCRPChangeIndices, promoPriceStats, marginOldUnit, marginOld, // (BM2)
  marginOldPercent, // (BM2%)
  marginNewUnit, marginNew, // added in LOG-4447 (Exp.BM2)
  marginNewPercent, // (Exp.BM2%)
  marginImpact, // added in LOG-4447 (ΔBM2)
  marginImpactPercent, // (ΔBM2%)
  salesVolumeOld, // added in LOG-4447 (Quantity)
  salesVolumeNew, // added in LOG-4447 (Exp.quantity)
  salesVolumeImpact, // added in LOG-4447 (ΔQuantity)
  revenueOld, // added in LOG-4447 (Sales)
  revenueNew, // (Exp.Sales)
  revenueImpact, // added in LOG-4447 (ΔSales)
  revenueImpactPercent, // added in LOG-4447 (ΔSales%)
  profitOldUnit, profitOld, // added in LOG-4447 (BM1)
  profitOldPercent, // added in LOG-5028 (BM1 %)
  profitNewUnit, profitNew, // added in LOG-4447 (Exp.BM1)
  profitNewPercent, // added in LOG-5028 (Exp.BM1 %)
  profitImpact, // added in LOG-4447 (ΔBM1)
  profitImpactPercent, // added in LOG-4447 (ΔBM1%)
  priceElasticity, optimizationGoal, finalPrice, exportedPriceHistory, priceCode, repricing, comments, realImpact) {
    var _this;

    _classCallCheck(this, PriceZoneReleasePrices);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneReleasePrices).call(this));
    _this.priceZoneId = priceZoneId;
    _this.competitorReferencePrice = competitorReferencePrice;
    _this.competitorReferencePrices = competitorReferencePrices;
    _this.referencePriceOld = referencePriceOld;
    _this.referencePrice = referencePrice;
    _this.referencePriceChangeIndexPercent = referencePriceChangeIndexPercent;
    _this.optimalPriceWithConstraints = optimalPriceWithConstraints;
    _this.optimalPriceWithoutConstraints = optimalPriceWithoutConstraints;
    _this.edlpPrice = edlpPrice;
    _this.regularPrice = regularPrice;
    _this.regularPriceChangeIndexPercent = regularPriceChangeIndexPercent;
    _this.regularPriceChangeWeightedIndexPercent = regularPriceChangeWeightedIndexPercent;
    _this.companyVsReferencePriceChangeIndexPercent = companyVsReferencePriceChangeIndexPercent;
    _this.companyVsCRPChangeIndices = companyVsCRPChangeIndices;
    _this.promoPriceStats = promoPriceStats;
    _this.marginOldUnit = marginOldUnit;
    _this.marginOld = marginOld;
    _this.marginOldPercent = marginOldPercent;
    _this.marginNewUnit = marginNewUnit;
    _this.marginNew = marginNew;
    _this.marginNewPercent = marginNewPercent;
    _this.marginImpact = marginImpact;
    _this.marginImpactPercent = marginImpactPercent;
    _this.salesVolumeOld = salesVolumeOld;
    _this.salesVolumeNew = salesVolumeNew;
    _this.salesVolumeImpact = salesVolumeImpact;
    _this.revenueOld = revenueOld;
    _this.revenueNew = revenueNew;
    _this.revenueImpact = revenueImpact;
    _this.revenueImpactPercent = revenueImpactPercent;
    _this.profitOldUnit = profitOldUnit;
    _this.profitOld = profitOld;
    _this.profitOldPercent = profitOldPercent;
    _this.profitNewUnit = profitNewUnit;
    _this.profitNew = profitNew;
    _this.profitNewPercent = profitNewPercent;
    _this.profitImpact = profitImpact;
    _this.profitImpactPercent = profitImpactPercent;
    _this.priceElasticity = priceElasticity;
    _this.optimizationGoal = optimizationGoal;
    _this.finalPrice = finalPrice;
    _this.exportedPriceHistory = exportedPriceHistory;
    _this.priceCode = priceCode;
    _this.repricing = repricing;
    _this.comments = comments;
    _this.realImpact = realImpact;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price zone release prices.
   */


  _createClass(PriceZoneReleasePrices, [{
    key: "isFinalPriceDifferentThanRegular",
    value: function isFinalPriceDifferentThanRegular() {
      return PriceFormulas_1.PriceFormulas.finalPriceDiffersFromRegular(this.finalPrice, this.regularPrice);
    }
  }, {
    key: "isFinalPriceDifferentThanEDLP",
    value: function isFinalPriceDifferentThanEDLP() {
      return PriceFormulas_1.PriceFormulas.finalPriceDiffersFromEDLP(this.finalPrice, this.edlpPrice);
    }
    /**
     * <b>Conditions are used directly within database queries, if it changes here, change it within the query.</b>
     * @returns old forecast of sales volume (for regular price) for 30 days.
     */

  }, {
    key: "getForecastOld",
    value: function getForecastOld() {
      //TODO Move this method to the service class.
      //TODO PROFACT-618 use only the preferred value according to GlobalSetting.finalPriceDefault
      // const globalSettings = await this.globalSettingsService.find();
      // See the documentation of this method.
      var forecast = null; // For forecastOld, order of optimal prices does not matter

      if (this.optimalPriceWithConstraints !== null) {
        forecast = this.optimalPriceWithConstraints.forecastOld;
      }

      if (forecast === null && this.optimalPriceWithoutConstraints !== null) {
        forecast = this.optimalPriceWithoutConstraints.forecastOld;
      }

      return forecast;
    }
    /**
     * Returns new forecast of sales volume (for new final price) for 30 days.
     */

  }, {
    key: "getForecastNew",
    value: function getForecastNew() {
      return this.finalPrice !== null ? this.finalPrice.forecast : null;
    }
    /**
     * Returns exported start date of new (final) price. Reused in both export and reporting.
     */

  }, {
    key: "getFinalPriceFrom",
    value: function getFinalPriceFrom() {
      return !utils_1.Utils.isValueMissing(this.repricing.possibleFrom) ? this.repricing.possibleFrom : this.finalPrice !== null ? this.finalPrice.validFrom : null;
    }
    /**
     * Returns exported end date of new (final) price. Reused in both export and reporting.
     */

  }, {
    key: "getFinalPriceTo",
    value: function getFinalPriceTo() {
      return this.finalPrice !== null ? !utils_1.Utils.isValueMissing(this.finalPrice.validTo) ? this.finalPrice.validTo : DateUtils_1.DateUtils.DATE_TO_INFINITY : null;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceZoneReleasePrices(mat.priceZoneId, mat.competitorReferencePrice, mat.competitorReferencePrices, mat.referencePriceOld, mat.referencePrice, mat.referencePriceChangeIndexPercent, mat.optimalPriceWithConstraints, mat.optimalPriceWithoutConstraints, mat.edlpPrice, mat.regularPrice, mat.regularPriceChangeIndexPercent, mat.regularPriceChangeWeightedIndexPercent, mat.companyVsReferencePriceChangeIndexPercent, mat.companyVsCRPChangeIndices, mat.promoPriceStats, mat.marginOldUnit, mat.marginOld, mat.marginOldPercent, mat.marginNewUnit, mat.marginNew, mat.marginNewPercent, mat.marginImpact, mat.marginImpactPercent, mat.salesVolumeOld, mat.salesVolumeNew, mat.salesVolumeImpact, mat.revenueOld, mat.revenueNew, mat.revenueImpact, mat.revenueImpactPercent, mat.profitOldUnit, mat.profitOld, mat.profitOldPercent, mat.profitNewUnit, mat.profitNew, mat.profitNewPercent, mat.profitImpact, mat.profitImpactPercent, mat.priceElasticity, mat.optimizationGoal, mat.finalPrice, mat.exportedPriceHistory, mat.priceCode, mat.repricing, mat.comments, null);
    }
  }]);

  return PriceZoneReleasePrices;
}(DomainObject_1.DomainObject);

exports.PriceZoneReleasePrices = PriceZoneReleasePrices;

PriceZoneReleasePrices.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceZoneReleasePrices.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    competitorReferencePrice: builder.opt(builder.obj('competitorReferencePrice', CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema, function (mat) {
      return CompetitorReferentialPrice_1.CompetitorReferentialPrice.fromDataDict(mat);
    })),
    competitorReferencePrices: builder.listOf(builder.obj('competitorReferencePrices', CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema, function (mat) {
      return CompetitorReferentialPrice_1.CompetitorReferentialPrice.fromDataDict(mat);
    })),
    referencePriceOld: builder.opt(builder.obj('referencePriceOld', ReferencePrice_1.ReferencePrice.schema, function (mat) {
      return ReferencePrice_1.ReferencePrice.fromDataDict(mat);
    })),
    referencePrice: builder.opt(builder.obj('referencePrice', ReferencePrice_1.ReferencePrice.schema, function (mat) {
      return ReferencePrice_1.ReferencePrice.fromDataDict(mat);
    })),
    referencePriceChangeIndexPercent: builder.opt(builder.obj('referencePriceChangeIndexPercent', PriceChangeIndex_1.PriceChangeIndex.schema, function (mat) {
      return PriceChangeIndex_1.PriceChangeIndex.fromDataDict(mat);
    })),
    optimalPriceWithConstraints: builder.opt(builder.obj('optimalPriceWithConstraints', OptimalPrice_1.OptimalPrice.schema, function (mat) {
      return OptimalPrice_1.OptimalPrice.fromDataDict(mat);
    })),
    optimalPriceWithoutConstraints: builder.opt(builder.obj('optimalPriceWithoutConstraints', OptimalPrice_1.OptimalPrice.schema, function (mat) {
      return OptimalPrice_1.OptimalPrice.fromDataDict(mat);
    })),
    edlpPrice: builder.opt(builder.obj('edlpPrice', ProductPrice_1.ProductPrice.productPriceSchema, function (mat) {
      return new ProductPrice_1.ProductPrice(mat.value, mat.vatId);
    })),
    regularPrice: builder.opt(builder.obj('regularPrice', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return new RegularProductPrice_1.RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    })),
    regularPriceChangeIndexPercent: builder.opt(builder.obj('regularPriceChangeIndexPercent', PriceChangeIndex_1.PriceChangeIndex.schema, function (mat) {
      return PriceChangeIndex_1.PriceChangeIndex.fromDataDict(mat);
    })),
    regularPriceChangeWeightedIndexPercent: builder.opt(builder.obj('regularPriceChangeWeightedIndexPercent', PriceChangeIndex_1.PriceChangeIndex.schema, function (mat) {
      return PriceChangeIndex_1.PriceChangeIndex.fromDataDict(mat);
    })),
    companyVsReferencePriceChangeIndexPercent: builder.opt(builder.obj('companyVsReferencePriceChangeIndexPercent', PriceChangeIndex_1.PriceChangeIndex.schema, function (mat) {
      return PriceChangeIndex_1.PriceChangeIndex.fromDataDict(mat);
    })),
    companyVsCRPChangeIndices: builder.listOf(builder.obj('companyVsCRPChangeIndices', CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex.schema, function (mat) {
      return CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex.fromDataDict(mat);
    })),
    promoPriceStats: builder.obj('promoPriceStats', PriceStats_1.PriceStats.schema, function (mat) {
      return new PriceStats_1.PriceStats(mat.currentPrices, mat.lastAmount, mat.minAmount, mat.averageAmount, mat.openingAmount);
    }),
    marginOldUnit: builder.opt(builder.bigNum('marginOldUnit')),
    marginOld: builder.opt(builder.bigNum('marginOld')),
    marginOldPercent: builder.opt(builder.bigNum('marginOldPercent')),
    marginNewUnit: builder.opt(builder.bigNum('marginNewUnit')),
    marginNew: builder.opt(builder.bigNum('marginNew')),
    marginNewPercent: builder.opt(builder.bigNum('marginNewPercent')),
    marginImpact: builder.opt(builder.bigNum('marginImpact')),
    marginImpactPercent: builder.opt(builder.bigNum('marginImpactPercent')),
    salesVolumeOld: builder.opt(builder.bigNum('salesVolumeOld')),
    salesVolumeNew: builder.opt(builder.bigNum('salesVolumeNew')),
    salesVolumeImpact: builder.opt(builder.bigNum('salesVolumeImpact')),
    revenueOld: builder.opt(builder.bigNum('revenueOld')),
    revenueNew: builder.opt(builder.bigNum('revenueNew')),
    revenueImpact: builder.opt(builder.bigNum('revenueImpact')),
    revenueImpactPercent: builder.opt(builder.bigNum('revenueImpactPercent')),
    profitOldUnit: builder.opt(builder.bigNum('profitOldUnit')),
    profitOld: builder.opt(builder.bigNum('profitOld')),
    profitOldPercent: builder.opt(builder.bigNum('profitOldPercent')),
    profitNewUnit: builder.opt(builder.bigNum('profitNewUnit')),
    profitNew: builder.opt(builder.bigNum('profitNew')),
    profitNewPercent: builder.opt(builder.bigNum('profitNewPercent')),
    profitImpact: builder.opt(builder.bigNum('profitImpact')),
    profitImpactPercent: builder.opt(builder.bigNum('profitImpactPercent')),
    priceElasticity: builder.opt(builder.bigNum('priceElasticity')),
    optimizationGoal: builder.opt(builder.senum('optimizationGoal', OptimizationGoalsSettings_1.OptimizationGoal, CodebookLookupSequence_1.CodebookLookupSequence.OptimizationGoalType)),
    finalPrice: builder.opt(builder.obj('finalPrice', FinalProductPrice_1.FinalProductPrice.schema, function (mat) {
      return FinalProductPrice_1.FinalProductPrice.fromDataDict(mat);
    })),
    exportedPriceHistory: builder.obj('exportedPriceHistory', ExportedPriceHistory_1.ExportedPriceHistory.schema, function (mat) {
      return ExportedPriceHistory_1.ExportedPriceHistory.fromDataDict(mat);
    }),
    priceCode: builder.opt(builder.str('priceCode')),
    repricing: builder.obj('repricing', ReleaseItemRepricing_1.ReleaseItemRepricing.schema, function (mat) {
      return new ReleaseItemRepricing_1.ReleaseItemRepricing(mat.possible, mat.possibleFrom, ValidationResult_1.ValidationResult.fromDataDict(mat.validationResult));
    }),
    comments: builder.listOf(builder.obj('comments', PriceComment_1.PriceComment.schema, function (mat) {
      return new PriceComment_1.PriceComment(mat.id, mat.releaseId, mat.priceZoneId, mat.userId, mat.username, mat.productId, mat.text, mat.persistent, mat.deleteOn);
    })),
    realImpact: builder.opt(builder.obj('realImpact', RealImpactValue_1.RealImpactValue.schema, RealImpactValue_1.RealImpactValue.ctor))
  };
}();